<template>
    <div>

        <div class="card">
            <header class="card-header grey-header">
                <div class="row flex-flow-column">
                    <div class="col"><strong>{{$t('agentDepositPay.postpaidPay')}}</strong></div>
                    <p class="desc"> {{$t('agentDepositPay.desc')}}</p></div>
            </header>
            <div class=" ">
                <div class="card-body max-w-1100 m-auto pt-0px">
                    <div class="topup-wrapper">

                        <cPaymentList @getPaySettingsList="getPaySettList"
                                      @getSelPayment="getSelectedPay"
                                      :paymentFor="paymentFor"
                                      :selectedPayObject="sSelectedPayTypeObj"
                        />
                        <br>
                        <div class="row" v-if="calculatedPayFee">
                            <div class="col-md-6 mb-15px">
                                <div class="payment-few-bottom h-100 d-flex flex-flow-column">
                                    <div class=" title"> {{$t('agentDepositPay.reference')}}</div>
                                    <div class="row flex-flow-column mt-auto" style="margin: 0px -10px;">
                                        <div class="col-md-12">
                                            <div class="total-wrap input">
                                                <cTextInputComponent v-model="paymentReference"
                                                                     :name="$t('agentDepositPay.reference')"
                                                                     :label="$t('agentDepositPay.paymentRef')" 
                                                      :maxLength="100"
                                                      
                   
                                                                     />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="col-md-6 mb-15px">
                                <div class="payment-few-bottom">
                                    <div class=" title"> {{$t('agentDepositPay.paymentFee')}} &amp; {{$t('agentDepositPay.total')}}</div>
                                    <div class="pay-table">
                                        <table>
                                            <tbody>

                                            <tr>
                                                <td>
                                                    {{$t('agentDepositPay.paymentAmount')}}
                                                </td>
                                                <td>
                                                    {{GET_SEL_POSTPAID_CURR}}
                                                </td>
                                                <td>
                                                    {{topupPayAmount}}
                                                </td>
                                            </tr>
                                            <tr>
                                                <td>
                                                    <!-- {{$t('agentDepositPay.topUpFees')}} -->
                                                    {{$t('agentDepositPay.paymentFees')}}
                                                </td>
                                                <td>
                                                    {{GET_SEL_POSTPAID_CURR}}
                                                </td>
                                                <td>
                                                    {{topUpFees}}
                                                </td>
                                            </tr>
                                            <tr>
                                                <td>
                                                    {{$t('agentDepositPay.totalAmount')}}
                                                </td>
                                                <td>
                                                    {{GET_SEL_POSTPAID_CURR}}
                                                </td>
                                                <td>
                                                    {{topUpTotal}}
                                                </td>
                                            </tr>
                                            </tbody>
                                        </table>
                                    </div>
<!--                                    <div class="row flex-flow-column">-->
<!--                                        <div class="col-md-3">-->
<!--                                            <div class="total-wrap label">-->



<!--                                                <div class="row t-wrap-topup">-->
<!--                                                    <div class="col-6 t-title"><label>{{$t('agentDepositPay.topUpFees')}}</label></div>-->
<!--                                                    <div class="col-6 t-value"><label>{{GET_SEL_POSTPAID_CURR}}</label><label> {{topUpFees}}</label>-->
<!--                                                    </div>-->
<!--                                                </div>-->
<!--                                            </div>-->
<!--                                        </div>-->
<!--                                        <div class="col-md-3">-->
<!--                                            <div class="total-wrap label">-->
<!--                                                <div class="row t-wrap-topup">-->
<!--                                                    <div class="col-6 t-title"><label>{{$t('agentDepositPay.totalAmount')}}</label></div>-->
<!--                                                    <div class="col-6 t-value"><label>{{GET_SEL_POSTPAID_CURR}}</label><label> {{topUpTotal}}</label>-->
<!--                                                    </div>-->
<!--                                                </div>-->
<!--                                            </div>-->
<!--                                        </div>-->
<!--                                        <div class="col-md-3">-->
<!--                                            <div class="total-wrap label">-->

<!--                                                <div class="row t-wrap-topup">-->
<!--                                                    <div class="col-6 t-title"><label>{{$t('agentDepositPay.totalAmount')}}</label></div>-->
<!--                                                    <div class="col-6 t-value"><label>{{GET_SEL_POSTPAID_CURR}}</label><label> {{topUpTotal}}</label>-->
<!--                                                    </div>-->
<!--                                                </div>-->
<!--                                            </div>-->
<!--                                        </div>-->
<!--                                    </div>-->
                                </div>
                            </div>
                        </div>
<!--                        <div class="payment-few-bottom" v-if="calculatedPayFee">-->
<!--                            <div class=" title"> Payment Fee &amp; Total</div>-->
<!--                            <div class="row ">-->
<!--                                <div class="col-md-4">-->
<!--                                    <div class="total-wrap label">-->
<!--                                        <div showicon="true">-->
<!--                                            <cTextInputComponent-->
<!--                                                    :currency="GET_SEL_POSTPAID_CURR"-->

<!--                                                    :isDisable="true"-->
<!--                                                    v-model="topUpFees"-->
<!--                                                    :name="$t('agentDepositPay.topUpFees')"-->


<!--                                                    :label="$t('agentDepositPay.topUpFees')"-->


<!--                                            />-->

<!--                                        </div>-->
<!--                                    </div>-->
<!--                                </div>-->


<!--                                <div class="col-md-4">-->
<!--                                    <div class="total-wrap label">-->
<!--                                        <cTextInputComponent-->
<!--                                                :currency="GET_SEL_POSTPAID_CURR"-->
<!--                                                :isDisable="true"-->
<!--                                                v-model="topUpTotal"-->
<!--                                                :name="$t('agentDepositPay.totalAmount')"-->
<!--                                                :label="$t('agentDepositPay.totalAmount')"-->
<!--                                        />-->
<!--                                    </div>-->
<!--                                </div>-->
<!--                                <div class="col-md-4">-->
<!--                                    <div class="total-wrap label">-->
<!--                                        <div showicon="true" class="">-->


<!--                                            <cTextInputComponent v-model="paymentReference"-->
<!--                                                                 :name="$t('agentDepositPay.reference')"-->
<!--                                                                 :label="$t('topUpPage.paymentRef')"/>-->

<!--                                        </div>-->
<!--                                    </div>-->
<!--                                </div>-->
<!--                            </div>-->

<!--                        </div>-->


                        <!--                        <div class="payment-few-bottom"  v-if="calculatedPayFee">-->
                        <!--                            <div class="row ">-->
                        <!--                                <div class="col-md-6">-->
                        <!--                                    <div class="max-width-500px restricted-w-br-r">-->
                        <!--                                        &lt;!&ndash; class="bg-blue-font-bold" &ndash;&gt;-->
                        <!--                                        <div showicon="true" class="total-price-payment" >-->
                        <!--                                            <cTextInputComponent-->
                        <!--                                                    :currency="GET_SEL_POSTPAID_CURR"-->

                        <!--                                                    :isDisable="true"-->
                        <!--                                                    v-model="topUpFees"-->
                        <!--                                                    :name="$t('agentDepositPay.topUpFees')"-->


                        <!--                                                    :label="$t('agentDepositPay.topUpFees')"-->


                        <!--                                            />-->

                        <!--                                        </div>-->
                        <!--                                    </div>-->
                        <!--                                    <br>-->
                        <!--                                    <div class="max-width-500px restricted-w-br-r">-->
                        <!--                                        <div showicon="true" class="">-->


                        <!--                                            <cTextInputComponent v-model="paymentReference" :name="$t('agentDepositPay.reference')" :label="$t('topUpPage.paymentRef')"/>-->

                        <!--                                        </div>-->
                        <!--                                    </div>-->


                        <!--                                    <br></div>-->
                        <!--                                <div class="col-md-6">-->
                        <!--                                    <div class="max-width-500px restricted-w-br-r ">-->
                        <!--                                        <div class="total-price-payment">-->
                        <!--                                            <div>-->

                        <!--                                                <cTextInputComponent-->
                        <!--                                                        :currency="GET_SEL_POSTPAID_CURR"-->
                        <!--                                                        :isDisable="true"-->
                        <!--                                                        v-model="topUpTotal"-->
                        <!--                                                        :name="$t('agentDepositPay.totalAmount')"-->
                        <!--                                                        :label="$t('agentDepositPay.totalAmount')"-->
                        <!--                                                />-->
                        <!--                                            </div>-->
                        <!--                                        </div>-->
                        <!--                                    </div>-->
                        <!--                                </div>-->
                        <!--                            </div>-->
                        <!--                        </div>-->


                    </div>
                </div>
            </div>
            <cAlertModal v-if="isBookFailAlert"
                         :show="isBookFailAlert"
                         :status="0"
                         :buttonList="getBookFailModalBtns()"
                         :desc="alertValue"
                         :failedTitle="getFailedTitle(alertValue)"
            ></cAlertModal>
            <cAlertModal v-if="isAlertWhileNav"
                         :buttonList="[
      { name:$t('ticketNowPage.okBtn'),func: navToResultPage,color: 'danger'},]"
                         :show="isAlertWhileNav"
                         :status="0"
                         :desc="alertValue"
            ></cAlertModal>

            <cAlertModal v-if="isSelPaymentAlert"
                         :buttonList="[
      { name:$t('paymentPage.selPayAlertOkBtn'),func: onHideSelPaymentAlert,color: 'danger'},]"
                         :show="isSelPaymentAlert"
                         :status="0"
                         :desc="$t('paymentPage.selectPayAlert')"
            ></cAlertModal>
            <footer v-if="!isHideFooter" class="card-footer d-flex justify-content-end">
                   <CCol class='d-flex justify-content-end'>

                  
                  <div class="main-cta-btn">
                      <CButton @click='navToPrev' color="danger"  class="action-c-btn">          
                    <img src="@imgPath/img/svg/icons/close.svg">

                {{ $t("paymentPage.goBack") }}
                </CButton>
                </div>
                 </CCol>
                <div class="main-cta-btn">
                    <button v-if="isPaySubmitted" col="12" type="submit" class="btn action-c-btn btn-success removewrap"
                            @click.once="onSubmitPayForPostPaidTopUp"><img
                            src="/img/correct.0d4e03c5.svg"> {{ $t('ticketNowPage.payBtn')}}
                    </button>
                </div>
            </footer>
        </div>


    </div>

</template>
<script>
    import cTextInputComponent from "../../components/form/cTextInputComponent";

    import BaseConfiguration from "../../config/base";
    import Logger from "../../services/logger";
    import apiCalPayFeeForPostPaidTopUp from "../../services/apiCalPayFeeForPostPaidTopUp";
    import {VALIDATE_SUCCESS_RES, getErrorMessage} from "@/util/apiValidate.js";
    import router, {navigate, goBack, updateDataEdited} from "../../router/index";

    import cAlertModal from "../../components/form/cAlertModal";

    import cPaymentList from "../../components/payment/cPaymentList";
    import {mapGetters, mapActions} from "vuex";
    import {
        handleJWT,
        getErrorAlertValue,
        cloneData,
        addClassToBody,
        removeClassBody,
        handleSessionExist,
        navigateByHostUrl,
        cloneDeep, parseNumber
    } from "../../util/util";
    import cPerPaxPriceInfo from "../../components/result/cPerPaxPriceInfo";
    import cTotalPriceInfo from "../../components/result/cTotalPriceInfo";
    import cSelFlightInfo from "../../components/result/cSelFlightInfo";
    import apiPostPaidAgentTopUp from "../../services/apiPostPaidAgentTopUp";
    import {
        LOG_TYPE,
        FILE_NAME,
        HTTP_CODES,
        API_VALUES
    } from "../../config/API_DATA";
    import {
        COMPONENT_NAME,
        PATHNAME,
        ROUTER_PARAM,
        PAX,
        TOAST_TYPE,
        PROCEED_TO_TYPE,
        PAYMENT_FOR,
        GENDER
    } from "../../util/constants";

    export default {
        components: {
            cPaymentList,
            cSelFlightInfo,
            cPerPaxPriceInfo,
            cTotalPriceInfo,
            cAlertModal,
            cTextInputComponent

        },
        computed: {

            ...mapGetters("sPaymentPage", {
                sSelectedPayTypeObj: "GET_SEL_PAY_TYPE_OBJ"
            }),
            ...mapGetters("sAgtLogin", {
                sSignInRes: "GET_SIGNIN_RES"
            }),
            ...mapGetters("sPostPaidTopUp", {
                GET_AMOUNT_FOR_POSTPAID: "GET_AMOUNT",
                GET_SEL_POSTPAID_CURR: "GET_SELECTED_CURRENCY",
                GET_STATEMENT_ID: "GET_STATEMENT_ID"
            }),
            // ...mapGetters("sResult", {
            //     selectedFlight: "GET_SEL_FLI_FRM_PRIC",
            //     // searchPricingReq: "GET_SEARCH_PRICING_REQ"
            //   }),
        },
        data: () => ({
            paymentFor: PAYMENT_FOR.POSTPAID_TOPUP,
            selectedPayType: {
                paymentsettingsid: null,
                groupId: null
            },
            alertValue: null,
            calculatedPayFee: null,
            isSelPaymentAlert: false, /// show alert to select payment type
            isAlertWhileNav: false, //get confirmation before navigating to results page
            bookingResponse: null, //createBookingRes
            isBookFailAlert: false,
            paymentReference: '',
            topUpFees: null,
            topUpTotal: null,
            isPaySubmitted: true,
            isHideFooter: false,
            topupPayAmount:null


        }),
//         watch: {
//     //to format amount in V-Model using filter method
//     topUpFees(val) {
//       try {
//         if (BaseConfiguration.isDebug) console.log(" topUpFees");
//  if(val&&this.GET_SEL_POSTPAID_CURR)
//         {
//         this.topUpFees = this.$options.filters.formatNumber(val,this.GET_SEL_POSTPAID_CURR);

//         }
//       } catch (err) {
//         let body = Logger.buildRequest(
//           FILE_NAME.TOPUP,
//           "error while formatting  amount in V-Model using filter method",
//           err.toString(),
//           "changeValue",
//           LOG_TYPE.ERROR
//         );
//         Logger.getResponse(body);
//       }
//     },
//      topUpTotalAmt(val) {
//       try {
//         if (BaseConfiguration.isDebug) console.log(" topUpTotalAmt");
//  if(val&&this.GET_SEL_POSTPAID_CURR)
//         {
//         this.topUpTotalAmt = this.$options.filters.formatNumber(val,this.GET_SEL_POSTPAID_CURR);

//         }
//       } catch (err) {
//         let body = Logger.buildRequest(
//           FILE_NAME.TOPUP,
//           "error while formatting  amount in V-Model using filter method",
//           err.toString(),
//           "changeValue",
//           LOG_TYPE.ERROR
//         );
//         Logger.getResponse(body);
//       }
//     }
//   },


        methods: {
            ...mapActions("sPaymentPage", {
                SET_PAY_TYPE_OBJ: "SET_PAY_TYPE_OBJ",
                SET_CREATE_BOOKING_RES: "SET_CREATE_BOOKING_RES"
            }),
            ...mapActions("sPostPaidTopUp", {
                SET_POST_PAID_PAY_RES: "SET_POST_PAID_PAY_RES"
            }),
             
             isInvoicePaidAlert(pAlertValue) {
                  let retValue;
                 try {
                   if(BaseConfiguration.isDebug) console.log("isInvoicePaidAlert");
                  
                if(pAlertValue&&pAlertValue.codeList){
                     for(let i=0;i<pAlertValue.codeList.length;i++){
                         if(pAlertValue.codeList[i]==HTTP_CODES.ERROR_INVOICES_PAID){
                             retValue=true;
                             break;
                         }
                     }
                   }
                 } catch (err) {
                         let body = Logger.buildRequest(
                           COMPONENT_NAME.AGENT_DEPOSIT_PAY,
                           "error in isInvoicePaidAlert",
                           err.toString(),
                           "isInvoicePaidAlert",
                           LOG_TYPE.ERROR
                         );
                         Logger.getResponse(body);
                       }
                   return retValue;
                 }, 
             
             getFailedTitle(pAlertValue) {
                  let retValue=null;
                 try {
                   if(BaseConfiguration.isDebug) console.log("getFailedTitle");
                   if(this.isInvoicePaidAlert(pAlertValue)){
                       retValue="Alert";
                   }
                 } catch (err) {
                         let body = Logger.buildRequest(
                           COMPONENT_NAME.AGENT_DEPOSIT_PAY,
                           "error in getFailedTitle",
                           err.toString(),
                           "getFailedTitle",
                           LOG_TYPE.ERROR
                         );
                         Logger.getResponse(body);
                       }
                   return retValue;
                 }, 
            
                
             navToPrev() {
                try {
                  if(BaseConfiguration.isDebug) console.log("navToPrev");
                
                              goBack()
                } catch (err) {
                        let body = Logger.buildRequest(
                           COMPONENT_NAME.AGENT_DEPOSIT_PAY,
                          "error in navToPrev",
                          err.toString(),
                          "navToPrev",
                          LOG_TYPE.ERROR
                        );
                        Logger.getResponse(body);
                      }
                  
                }, 

            getPaySettList(pPaySettingsLs) {
                try {
                    if (BaseConfiguration.isDebug) console.log("getPaySettList");
                    if (!(pPaySettingsLs.length > 0)) {
                        this.isHideFooter = true;
                    }

                } catch (err) {
                    let body = Logger.buildRequest(
                        COMPONENT_NAME.AGENT_DEPOSIT_PAY,
                        "error in getPaySettList",
                        err.toString(),
                        "getPaySettList",
                        LOG_TYPE.ERROR
                    );
                    Logger.getResponse(body);
                }

            },

            async getSelectedPay(pPaymentType) {
                try {
                    if (BaseConfiguration.isDebug) console.log("getSelectedPay");
                    this.selectedPayType.paymentsettingsid = pPaymentType.paymentsettingsid;
                    this.selectedPayType.groupId = pPaymentType.groupId;
                    let retSelectedPayment = await this.getSelectPayForPostPaid(
                        pPaymentType.paymentsettingsid
                    );
                    this.calculatedPayFee = retSelectedPayment;
                    this.topUpFees = this.$options.filters.formatNumber(this.calculatedPayFee.fee.toString(), this.GET_SEL_POSTPAID_CURR);
                    this.topUpTotal = this.$options.filters.formatNumber(this.calculatedPayFee.total.toString(), this.GET_SEL_POSTPAID_CURR);
                    this.topupPayAmount=this.$options.filters.formatNumber(this.calculatedPayFee.orderAmount.toString(), this.GET_SEL_POSTPAID_CURR);
                    if (retSelectedPayment) {
                        this.calculatedPayFee = null;
                        setTimeout(() => {
                            this.calculatedPayFee = retSelectedPayment;
                        });

                    }
                    updateDataEdited(true);
                } catch (err) {
                    let body = Logger.buildRequest(
                        COMPONENT_NAME.AGENT_DEPOSIT_PAY,
                        "error in getSelectedPay",
                        err.toString(),
                        "getSelectedPay",
                        LOG_TYPE.ERROR
                    );
                    Logger.getResponse(body);
                }
            },


            async getSelectPayForPostPaid(pPaymentsettingsid, pOrderId) {
                try {
                    let retValue;
                    if (BaseConfiguration.isDebug) console.log("getSelectPayForPostPaid");
                    let selectPayRequest = apiCalPayFeeForPostPaidTopUp.buildRequest(
                        this.GET_AMOUNT_FOR_POSTPAID,
                        pPaymentsettingsid, this.GET_SEL_POSTPAID_CURR
                    );

                    if (selectPayRequest) {
                        let selectPayResponse = await apiCalPayFeeForPostPaidTopUp.getResponse(
                            selectPayRequest
                        );


                        if (VALIDATE_SUCCESS_RES(selectPayResponse)) {
                            //VALIDATE_SUCCESS_RES(selectPayResponse)
                            retValue = selectPayResponse.data.data;
                        } else {
                            let error = getErrorMessage(selectPayResponse);
                            // if (retSessionVal) {
                            //   this.showToast(retSessionVal, TOAST_TYPE.ERROR, 5000, null);
                            // }
                            let isJwt = handleJWT(error);
                            if (!isJwt && selectPayResponse) {
                                let isSessionExpired = handleSessionExist(selectPayResponse.data);
                                if (!isSessionExpired) {
                                    this.alertValue = getErrorAlertValue(error);
                                }
                            }
                        }
                    } else {
                        throw "invalid select payment request";
                    }
                    return retValue;
                } catch (err) {
                    let body = Logger.buildRequest(
                        COMPONENT_NAME.AGENT_DEPOSIT_PAY,
                        "error in getSelectPayForPostPaid",
                        err.toString(),
                        "getSelectPayForPostPaid",
                        LOG_TYPE.ERROR
                    );
                    Logger.getResponse(body);
                }
            },


            async onSubmitPayForPostPaidTopUp() {
                try {
                    if (BaseConfiguration.isDebug) console.log("onSubmitPayForPostPaidTopUp");
                    updateDataEdited(false);

                    if (

                        this.selectedPayType &&
                        this.selectedPayType.paymentsettingsid && this.calculatedPayFee.orderAmount
                    ) {
                        let statementsIdLs = [];
                        if (this.GET_STATEMENT_ID) {
                            for(let i=0;i<this.GET_STATEMENT_ID.length;i++){
                            statementsIdLs.push(Number(this.GET_STATEMENT_ID[i]));

                            }
                        }

                        let topUpDet = {
                            "statementsId": statementsIdLs,
                            "paymentCurrency": this.GET_SEL_POSTPAID_CURR,
                            "totalAmount": this.calculatedPayFee.orderAmount,
                            "paymentSettingsId": this.selectedPayType.paymentsettingsid,
                            "ref": this.paymentReference

                            // amount: parseNumber(this.calculatedPayFee.total),

                            // paymentSettingsId: this.selectedPayType.paymentsettingsid,
                            // currency: this.getCurrencyCode(this.currency)
                        };
                        let retBookingResponse = await this.createDepositForPostPaid(topUpDet);
                        this.SET_POST_PAID_PAY_RES(retBookingResponse);
                        if (retBookingResponse) {
                            this.bookingResponse = retBookingResponse;
                            this.navByProceedTo(this.bookingResponse);
                        } else {
                            this.reCreatePayBtn();
                            this.toggleBookFailAlert();
                        }
                    } else {

                        this.isSelPaymentAlert = true;
                        this.reCreatePayBtn();
                    }
                } catch (err) {
                    let body = Logger.buildRequest(
                        COMPONENT_NAME.AGENT_DEPOSIT_PAY,
                        "error in onSubmitPayForPostPaidTopUp",
                        err.toString(),
                        "onSubmitPayForPostPaidTopUp",
                        LOG_TYPE.ERROR
                    );
                    Logger.getResponse(body);
                }
            },
            reCreatePayBtn() {
                try {
                    if (BaseConfiguration.isDebug) console.log("reCreatePayBtn");
                    this.isPaySubmitted = false;
                    let that = this;
                    setTimeout(() => {
                        that.isPaySubmitted = true;
                    }, 100);

                } catch (err) {
                    let body = Logger.buildRequest(
                        COMPONENT_NAME.AGENT_DEPOSIT_PAY,
                        "error in reCreatePayBtn",
                        err.toString(),
                        "reCreatePayBtn",
                        LOG_TYPE.ERROR
                    );
                    Logger.getResponse(body);
                }

            },


            ///to call create payment for ticketing api
            async createDepositForPostPaid(pTopUpDet) {
                let retValue;
                try {
                    if (BaseConfiguration.isDebug) console.log("createDepositForPostPaid");

                    let bookingReq = apiPostPaidAgentTopUp.buildRequest(pTopUpDet);

                    if (bookingReq) {
                        let bookingRes = await apiPostPaidAgentTopUp.getResponse(
                            bookingReq
                        );

                        if (VALIDATE_SUCCESS_RES(bookingRes)) {//VALIDATE_SUCCESS_RES(bookingRes)
                            this.SET_CREATE_BOOKING_RES(bookingRes);

                            if (BaseConfiguration.isDebug) {
                                if (
                                    // to print PNRs in console
                                    bookingRes.data &&
                                    bookingRes.data.data &&
                                    bookingRes.data.data.bookingStatus &&
                                    bookingRes.data.data.bookingStatus.BookingDetails
                                ) {
                                    for (
                                        let t = 0;
                                        t < bookingRes.data.data.bookingStatus.BookingDetails.length;
                                        t++
                                    ) {
                                        console.log(
                                            JSON.stringify(
                                                bookingRes.data.data.bookingStatus.BookingDetails[t].pnr
                                            )
                                        );
                                    }
                                }
                            }

                            ///if booked is true
                            if (
                                bookingRes.data.data &&
                                bookingRes.data.data.isBooked
                            ) {
                                retValue = bookingRes.data.data;
                            } ///if booked false ,but status success
                            else {
                                retValue = bookingRes.data.data;
                                this.handleBookingFailed(retValue);
                            }
                        } else {
                            //if status error
                            retValue = null;
                            let error = getErrorMessage(bookingRes);

                            let isJwt = handleJWT(error);
                            if (!isJwt && bookingRes) {
                                let isSessionExpired = handleSessionExist(bookingRes.data);
                                if (!isSessionExpired) {
                                    this.alertValue = getErrorAlertValue(error, true, true);
                                }
                            }
                        }
                    }
                } catch (err) {
                    let body = Logger.buildRequest(
                        COMPONENT_NAME.AGENT_DEPOSIT_PAY,
                        "error in getting response from create booking API",
                        err.toString(),
                        "createDepositForPostPaid",
                        LOG_TYPE.ERROR
                    );
                    Logger.getResponse(body);
                }
                return retValue;
            },
            ///to handling the failed case of booking
            handleBookingFailed(pBookingRes) {
                try {
                    if (BaseConfiguration.isDebug) console.log("handleBookingFailed");

                    //if status success, but it contains error obj
                    let errList = [];
                    if (
                        pBookingRes.hasOwnProperty("bookingStatus") &&
                        pBookingRes.bookingStatus.BookingDetails
                    ) {
                        for (
                            let i = 0;
                            i < pBookingRes.bookingStatus.BookingDetails.length;
                            i++
                        ) {
                            if (
                                pBookingRes.bookingStatus.BookingDetails[i].hasOwnProperty(
                                    "error"
                                )
                            ) {
                                if (
                                    pBookingRes.bookingStatus.BookingDetails[i].error &&
                                    pBookingRes.bookingStatus.BookingDetails[i].error
                                        .constructor === Array
                                ) {
                                    for (
                                        let j = 0;
                                        j < pBookingRes.bookingStatus.BookingDetails[i].error.length;
                                        j++
                                    ) {
                                        errList.push(
                                            pBookingRes.bookingStatus.BookingDetails[i].error[j]
                                        );
                                    }
                                } else {
                                    errList.push(pBookingRes.bookingStatus.BookingDetails[i].error);
                                }
                            } else {
                                this.alertValue = this.$t('agentDepositPay.cantBook');
                            }
                        }
                    }
                    this.alertValue = errList;
                } catch (err) {
                    let body = Logger.buildRequest(
                        COMPONENT_NAME.AGENT_DEPOSIT_PAY,
                        "error in handleBookingFailed",
                        err.toString(),
                        "handleBookingFailed",
                        LOG_TYPE.ERROR
                    );
                    Logger.getResponse(body);
                }
            },
///to assign particular values to query to navigate another domain
            getPayQueryValues(pBookingStatus) {
                let retValue;
                try {
                    if (BaseConfiguration.isDebug) console.log("getPayQueryValues");

                    let param = {};
                    if (pBookingStatus) {
                        // param[ROUTER_PARAM.SESSION] = this.$router.currentRoute.query[
                        //   ROUTER_PARAM.SESSION_ID
                        // ];
                        param[ROUTER_PARAM.PROVIDER_ID] = pBookingStatus.paymentProviderId;
                        param[ROUTER_PARAM.ORDER_PAYMENT_ID] = pBookingStatus.orderPaymentId;
                        param[ROUTER_PARAM.TOKEN] = this.sSignInRes.authorization;
                        if (BaseConfiguration.paymentDebugUrl != null) {
                            param[ROUTER_PARAM.PAYMENT_DEBUG_URL] = BaseConfiguration.paymentDebugUrl;
                        }

                        retValue = param;
                    }
                } catch (err) {
                    let body = Logger.buildRequest(
                        COMPONENT_NAME.AGENT_DEPOSIT_PAY,
                        "error in getPayQueryValues",
                        err.toString(),
                        "getPayQueryValues",
                        LOG_TYPE.ERROR
                    );
                    Logger.getResponse(body);
                }
                return retValue;
            },


            ///navigate to corresponding pages using proceedTo from booking response
            navByProceedTo(pBookingStatus) {

                try {
                    if (BaseConfiguration.isDebug) console.log("navByProceedTo");

                    switch (pBookingStatus.proceedTo) {
                        case PROCEED_TO_TYPE.HOLD_PAGE: {
                            navigate(PATHNAME.HOLDPAGE);
                        }
                            break;
                        case PROCEED_TO_TYPE.FLIGHT_RESULTS_PAGE: {
                            if (this.alertValue && !pBookingStatus.isBooked) {
                                //if booked failed,having error and proceedTo FlightResultPage

                                this.toggleAlertWhileNav(); ///show alert and navigate to resultpage
                            }
                        }
                            break;
                        case PROCEED_TO_TYPE.PAYMENT_GATEWAY: {
                            let retQuery = this.getPayQueryValues(pBookingStatus);

                            if (retQuery) {
                                navigateByHostUrl(PATHNAME.PAYMENTGATEWAY, retQuery, false);
                            } else {
                                throw "invalid queries";
                            }
                        }
                            break;
                        case PROCEED_TO_TYPE.TICKET_SUCCESS_PAGE: {
                            navigate(PATHNAME.SUCCESSPAGE);
                        }
                            break;

                        default:
                            throw "invalid navigation proceed ";
                            break;
                    }
                } catch (err) {
                    let body = Logger.buildRequest(
                        COMPONENT_NAME.AGENT_DEPOSIT_PAY,
                        "error in navByProceedTo",
                        err.toString(),
                        "navByProceedTo",
                        LOG_TYPE.ERROR
                    );
                    Logger.getResponse(body);
                }
            },

            getBookFailModalBtns() {

                return [
                    {
                        name: this.$t("ticketNowPage.okBtn"),
                        func: this.onFailedProceed,
                        color: "danger"
                    }
                ];
            },

            onFailedProceed() {
                try {
                    if (BaseConfiguration.isDebug) console.log("onFailedProceed");
                    if(this.isInvoicePaidAlert(this.alertValue)){
                        navigate(PATHNAME.AGENT_DEPOSIT);
                    }else{
                         this.$router.go();
                    }
                   

                } catch (err) {
                    let body = Logger.buildRequest(
                        COMPONENT_NAME.AGENT_DEPOSIT_PAY,
                        "error in onFailedProceed",
                        err.toString(),
                        "onFailedProceed",
                        LOG_TYPE.ERROR
                    );
                    Logger.getResponse(body);
                }
            },

            ///to navigate flightResult page from alert
            navToResultPage() {
                try {
                    if (this.$route.path != PATHNAME.FLIGHTRESULTS) {
                        navigate(PATHNAME.FLIGHTRESULTS);
                    }
                } catch (err) {
                    let body = Logger.buildRequest(
                        COMPONENT_NAME.AGENT_DEPOSIT_PAY,
                        "error in navToResultPage",
                        err.toString(),
                        "navToResultPage",
                        LOG_TYPE.ERROR
                    );
                    Logger.getResponse(body);
                }
            },

            ///to show alert,if booking response status error
            onHideSelPaymentAlert() {
                try {
                    if (BaseConfiguration.isDebug) console.log("onHideSelPaymentAlert");

                    this.isSelPaymentAlert = false;
                } catch (err) {
                    let body = Logger.buildRequest(
                        COMPONENT_NAME.AGENT_DEPOSIT_PAY,
                        "error in onHideSelPaymentAlert",
                        err.toString(),
                        "onHideSelPaymentAlert",
                        LOG_TYPE.ERROR
                    );
                    Logger.getResponse(body);
                }
            },

            ///to show alert,if booking response status error
            toggleBookFailAlert() {
                try {
                    if (BaseConfiguration.isDebug) console.log("toggleBookFailAlert");

                    this.isBookFailAlert = !this.isBookFailAlert;
                } catch (err) {
                    let body = Logger.buildRequest(
                        COMPONENT_NAME.AGENT_DEPOSIT_PAY,
                        "error in toggleBookFailAlert",
                        err.toString(),
                        "toggleBookFailAlert",
                        LOG_TYPE.ERROR
                    );
                    Logger.getResponse(body);
                }
            },

            ///show alert to navigate to resultpage
            toggleAlertWhileNav() {
                try {
                    if (BaseConfiguration.isDebug) console.log("toggleAlertWhileNav");

                    this.isAlertWhileNav = !this.isAlertWhileNav;
                } catch (err) {
                    let body = Logger.buildRequest(
                        COMPONENT_NAME.AGENT_DEPOSIT_PAY,
                        "error in toggleAlertWhileNav",
                        err.toString(),
                        "toggleAlertWhileNav",
                        LOG_TYPE.ERROR
                    );
                    Logger.getResponse(body);
                }
            },

        },
        beforeCreate() {
            addClassToBody(COMPONENT_NAME.AGENT_DEPOSIT_PAY);
        },

        beforeDestroy() {
            removeClassBody();
        },
        created() {
        }
    };
</script>
